import React from 'react';
import VisitorProgramView from './VisitorProgramView';
import Layout from '../../components/Layout';
import { Redirect } from 'react-router-dom';

async function action({ params }) {
  return {
    title: 'Programs- Visitor',
    component: (
      <Redirect to={`/program_brochure/${params.program_id}`}>
        <Layout>
          <VisitorProgramView id={params.program_id} />
        </Layout>
      </Redirect>
    ),
  };
}

export default action;
